import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useState } from "react";
import '../../../assets/style/style.css';
import { dateTimeFormat, checkPrivilege } from "common.js";
import { useTranslation } from "react-i18next";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ApprovePopup from "./ApprovePopup.js";
import { PRIVILEGE } from "constants.js";

function RefundSummary(props) {
  const { t }                                   = useTranslation();
  const refundID                                = props.refundID;
  const adminType                               = window.localStorage.getItem('type');
  const [pageContent, setPageContent]           = useState(props.pageContent);
  const [approvePopupOpen, setApprovePopupOpen] = useState(false);

  const renderBankInfo = () => {
    const items    = [];
    const data     = JSON.parse(pageContent.customerBankInfo);
    const dataJSON = data;

    for (const key in dataJSON) {
      if (dataJSON.hasOwnProperty(key)) {
        items.push(
          <Box className="returnStatusBox" key={key} my={1}>
            <div className="returnStatusBoxLeft">{t(key)}</div>
            <div className="returnStatusBoxMiddle">:</div>
            <div className="returnStatusBoxRight">{dataJSON[key]}</div>
          </Box>  
        );
      }
    }

    return items;
  };
  
  return (
            <>
            <Grid container spacing={0} mt={1}>
              <Grid item sm={6} xs={12} my={1}>
                <Typography sx={{ fontSize: 14 }} component="div">
                  <Box className="returnStatusBox">
                    <div className="returnStatusBoxLeft">{t('Refund Amount')}</div>
                    <div className="returnStatusBoxMiddle">:</div>
                    <div className="returnStatusBoxRight">
                      {`₹${pageContent.totalPrice.toFixed(2)}`}
                    </div>
                  </Box>  
                </Typography> 
              </Grid>

              <Grid item sm={6} xs={12} my={1}>
                <Typography sx={{ fontSize: 14 }} component="div">
                  <Box className="returnStatusBox">
                    <div className="returnStatusBoxLeft">{t('Refund Status')}</div>
                    <div className="returnStatusBoxMiddle">:</div>
                    <div className="returnStatusBoxRight returnStatusBoxAction">

                      {(pageContent.refundedStatus === 'pending' && (adminType == PRIVILEGE.ADMIN || checkPrivilege("refunds", "write"))) ?      
                        <Box sx={{ display: 'flex' }}>
                          <Box sx={{ paddingTop: '6px' }}>
                            {t(pageContent.refundedStatus)}
                          </Box> 
                          <Box 
                              className="squareBoxRefundApprove"                            
                              onClick={() => setApprovePopupOpen(true)}
                          >
                            <CheckCircleOutlineIcon color="success" fontSize="medium" titleAccess={t("Refund Approve")} />
                          </Box>
                        </Box>  
                      : <>{t(pageContent.refundedStatus)}</>
                      }

                      {approvePopupOpen ?
                        <ApprovePopup
                          refundID={refundID}
                          pageContent = {pageContent}
                          setPageContent = {setPageContent}
                          approvePopupOpen = {approvePopupOpen}                              
                          setApprovePopupOpen = {setApprovePopupOpen}
                        />
                      :
                      null}     
                      
                    </div>
                  </Box>  
                </Typography> 
              </Grid>

              <Grid item sm={6} xs={12} my={1}>                       
                <Typography sx={{ fontSize: 14 }} component="div">
                  <Box className="returnStatusBox">
                    <div className="returnStatusBoxLeft">{t('Requested On')}</div>
                    <div className="returnStatusBoxMiddle">:</div>
                    <div className="returnStatusBoxRight">
                      {dateTimeFormat(pageContent.createdAt)}
                    </div>
                  </Box>  
                </Typography> 
              </Grid>

              <Grid item sm={6} xs={12} my={1}>
                <Typography sx={{ fontSize: 14 }} component="div">
                  <Box className="returnStatusBox">
                    <div className="returnStatusBoxLeft">{t('Processed On')}</div>
                    <div className="returnStatusBoxMiddle">:</div>
                    <div className="returnStatusBoxRight">                      
                      {pageContent.refundedStatus === 'approved' ? dateTimeFormat(pageContent.updatedAt) : "-"}
                    </div>
                  </Box>  
                </Typography>     
              </Grid>

              <Grid item sm={6} xs={12} my={1}>                       
                <Typography sx={{ fontSize: 14 }} component="div">
                  <Box className="returnStatusBox">
                    <div className="returnStatusBoxLeft">{t('Vendor Shop Name')}</div>
                    <div className="returnStatusBoxMiddle">:</div>
                    <div className="returnStatusBoxRight">
                      {pageContent.vendorShop}
                    </div>
                  </Box>  
                </Typography> 
              </Grid>

              <Grid item sm={6} xs={12} my={1}>                       
                <Typography sx={{ fontSize: 14 }} component="div">
                  <Box className="returnStatusBox">
                    <div className="returnStatusBoxLeft">{t('Vendor Order ID')}</div>
                    <div className="returnStatusBoxMiddle">:</div>
                    <div className="returnStatusBoxRight">
                      {"#"+pageContent.orderVendorId}
                    </div>
                  </Box>  
                </Typography> 
              </Grid>
              
              <Grid item sm={6} xs={12} my={1}>
                <Typography sx={{ fontSize: 14 }} component="div">
                  <Box className="returnStatusBox">
                    <div className="returnStatusBoxLeft">{t('Customer')}</div>
                    <div className="returnStatusBoxMiddle">:</div>
                    <div className="returnStatusBoxRight">
                      {pageContent.customerEmail}
                    </div>
                  </Box>  
                </Typography> 
              </Grid>

              <Grid item sm={6} xs={12} my={1}>                
                <Typography sx={{ fontSize: 14 }} component="div">
                  <Box className="returnStatusBox">
                    <div className="returnStatusBoxLeft">{t('Payment Mode')}</div>
                    <div className="returnStatusBoxMiddle">:</div>
                    <div className="returnStatusBoxRight">
                      {pageContent.cod && pageContent.cod === 1 ?    
                        t("COD")
                      : t("Pre-paid") 
                      }
                    </div>
                  </Box>  
                </Typography>                        
              </Grid>         

              <Grid item sm={6} xs={12} my={1}>
                <Typography sx={{ fontSize: 14 }} component="div">
                  <Box className="returnStatusBox">
                    <div className="returnStatusBoxLeft">{t('Transaction Type')}</div>
                    <div className="returnStatusBoxMiddle">:</div>
                    <div className="returnStatusBoxRight">
                      {t(pageContent.transactionType)}
                    </div>
                  </Box>  
                </Typography> 
              </Grid>

              {pageContent.returnReferenceId ?     
                <Grid item sm={6} xs={12} my={1}>
                  <Typography sx={{ fontSize: 14 }} component="div">
                    <Box className="returnStatusBox">
                      <div className="returnStatusBoxLeft">{t('Return Reference ID')}</div>
                      <div className="returnStatusBoxMiddle">:</div>
                      <div className="returnStatusBoxRight">
                        {"#"+pageContent.returnReferenceId}
                      </div>
                    </Box>  
                  </Typography> 
                </Grid>
              : null}
              
              {pageContent.transactionReferenceNumber ?     
                <Grid item sm={6} xs={12} my={1}>
                  <Typography sx={{ fontSize: 14 }} component="div">
                    <Box className="returnStatusBox">
                      <div className="returnStatusBoxLeft">{t('Transaction Reference No')}</div>
                      <div className="returnStatusBoxMiddle">:</div>
                      <div className="returnStatusBoxRight">
                        {"#"+pageContent.transactionReferenceNumber}
                      </div>
                    </Box>  
                  </Typography> 
                </Grid>
              : null}

              {pageContent.adminRemarks ?         
                <Grid item xs={12} my={1}>                
                  <Typography sx={{ fontSize: 14 }} component="div">
                    <Box className="returnStatusBox">
                      <div className="returnStatusBoxLeft">{t('Remarks')}</div>
                      <div className="returnStatusBoxMiddle">:</div>
                      <div className="returnStatusBoxRight">
                        {pageContent.adminRemarks}
                      </div>
                    </Box>  
                  </Typography>                        
                </Grid>              
              : null}
                               

              {pageContent.cod && pageContent.cod === 1 && pageContent.customerBankInfo ?
                <>
                  <Grid item xs={12} my={1}>                
                    <Typography sx={{ fontSize: 14 }} component="div">
                      <Box className="returnStatusBox">
                        <div className="returnStatusBoxLeft">
                          <Typography variant="h6" color="text.secondary">
                            {t('Refund Bank Details')}
                          </Typography>
                        </div>
                        <div className="returnStatusBoxMiddle"></div>
                        <div className="returnStatusBoxRight"></div>
                      </Box>  
                    </Typography>                        
                  </Grid>     

                  <Grid item xs={12} my={1}>                
                    <Typography sx={{ fontSize: 14 }} component="div">
                      {renderBankInfo()}  
                    </Typography>                        
                  </Grid>     
                </>
              : null}  
            </Grid>            
          </>                       
        );
}
export default RefundSummary;
